import React from "react";
import {Form, Input, InputNumber, Modal} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

function DocumentsClassificationModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return (
        <Modal {...otherProps}>
            <Form form={form} layout="vertical">
                <Form.Item label={'Country'} name={'country'}
                           rules={[{required: true, message: 'Please input country'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'CPQ Cost Upcharge'} name={'costUpcharge'}
                           rules={[{required: true, message: 'Please input CPQ cost upcharge'}]}>
                    <InputNumber precision={0} min={0}/>
                </Form.Item>
                <Form.Item label={'Tariff Surcharge'} name={'tariffSurcharge'}
                           rules={[{required: true, message: 'Please input Tariff Surcharge'}]}>
                    <InputNumber precision={1} min={0}/>
                </Form.Item>
                <Form.Item label={'Tariff Rate'} name={'tariffRate'}
                           rules={[{required: true, message: 'Please input Tariff Rate'}]}>
                    <InputNumber precision={1} min={0}/>
                </Form.Item>
                <Form.Item label={'Freight Rate'} name={'freightRate'}
                           rules={[{required: true, message: 'Please input Freight Rate'}]}>
                    <InputNumber precision={1} min={0}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default DocumentsClassificationModal;
